import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import {SharedComponentsModule} from '../../bonding_shared/components/shared-components.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CompanyModule} from '../company/company.module';
import {DocumentModule} from '../document/document.module';
import {InvoiceItemModule} from '../invoice-item/invoice-item.module';
import {CompanySharedModule} from '../company/components/shared/company-shared.module';
import {FINoteSearchComponent} from './fi-note-search.component';
import {FINoteGuiService} from './services/fi-note-gui.service';
import {FINoteDetailsComponent} from './fi-note-details.component';

@NgModule({
  imports: [
    RouterModule,
    BrowserModule,
    SharedComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    CompanyModule,
    DocumentModule,
    InvoiceItemModule,
    CompanySharedModule,
  ],
  declarations: [FINoteSearchComponent, FINoteDetailsComponent],
  exports: [],
  providers: [FINoteGuiService],
})
export class FINoteModule {}
